// extracted by mini-css-extract-plugin
export default {"wrapper":"UploadEmptyState_wrapper__IHfd4","uploadBtn":"UploadEmptyState_uploadBtn__WGhhy"};